import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Box } from '@chakra-ui/react';

import PlanPermission from 'container/PlanPermission';
import { getBaseScenario } from 'redux/PlannerModeSlice';
import apiService from 'services';
import Map from 'pages/BuilderMode/MapTab/Map';

import MapIndicatorNodeV1 from './MapIndicatorNodeV1';

import './BuilderModeMapTabV1.scss';

const BuilderModeMapTabV1 = () => {
  const { blockId } = useParams();
  const [initialNodes, setInitialNodes] = useState([]);
  const [initialEdges, setInitialEdges] = useState([]);
  const baseScenario = useSelector(getBaseScenario);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiService.getBlockMap(blockId, {
          params: { scenario_id: baseScenario?.scenario_id },
        });

        if (response.data.length > 0) {
          const sourceElements = response.data;
          const nodes = sourceElements.reduce((accumulator: any, sourceElement: any) => {
            if (Object.prototype.hasOwnProperty.call(sourceElement, 'data')) {
              sourceElement.type = 'indicator';
              sourceElement.id = String(sourceElement.id);
              sourceElement.position = { x: 0, y: 0 };
              accumulator.push(sourceElement);
            }
            return accumulator;
          }, []);

          const edges = sourceElements.reduce((accumulator: any, sourceElement: any) => {
            if (Object.prototype.hasOwnProperty.call(sourceElement, 'source')) {
              sourceElement.type = 'smoothstep';
              sourceElement.animated = false;
              sourceElement.markerEnd = { type: 'arrow' };
              accumulator.push(sourceElement);
            }
            return accumulator;
          }, []);

          setInitialNodes(nodes);
          setInitialEdges(edges);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [baseScenario, blockId]);

  if (!initialNodes?.length) {
    return null;
  }

  return (
    <Box
      className='builder-mode-v1-map-tab'
      flex='1'
      minH={0}
      h='100%'
      overflow='hidden'
      display='flex'
      flexDirection='column'
      borderRadius='16px'
      border='1px solid'
      borderColor='blockOverview.border'
      bg='white'
    >
      <Map
        initialNodes={initialNodes}
        initialEdges={initialEdges}
        indicatorNodeComponent={MapIndicatorNodeV1}
      />
    </Box>
  );
};

export default PlanPermission(BuilderModeMapTabV1);
